import { render } from "./ModeloImprimir.vue?vue&type=template&id=645bc46c&scoped=true"
import script from "./ModeloImprimir.vue?vue&type=script&lang=js"
export * from "./ModeloImprimir.vue?vue&type=script&lang=js"

import "./ModeloImprimir.vue?vue&type=style&index=0&id=645bc46c&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645bc46c"]])

export default __exports__